const Saetze = require('./saetze.js');
import {formatPrice} from './logic';

/** Bedarf Studenten-Bafög ausgeben
 *
 * @param $this
 * @param aus
 */
function grundbedarf_stud($this, aus = false){
    $this.el$('results.anspruch').value = aus ? formatPrice(0) : formatPrice(Saetze.saetze.b.grundbedarf)
}

/** Bedarf Meister-Bafög ausgeben
 *
 * @param $this
 * @param vollzeit
 * @param aus
 */
function grundbedarf_meister($this, vollzeit = true, aus = false){
    if (aus) {
        $this.el$('results.anspruch').value = formatPrice(0)
    }else {
        if( vollzeit ){
            $this.el$('results.anspruch').value = formatPrice(Saetze.saetze.aufstiegsbafoeg.selbst)
        }else if( !vollzeit ) { // TODO Teilzeit Kinder berechnung
            $this.el$('results.anspruch').value = formatPrice(0)
        }else{
            $this.el$('results.anspruch').value = formatPrice(0)
        }
    }
}

/**
 * Bedarf Schüler-Bafög - ohne vorausgesetzte Ausbildung - ausgeben
 * @param $this
 * @param art
 */
function grundbedarf_schule($this, art){
    switch (art) {
        case 'allg_schule':
            $this.el$('results.anspruch').value = formatPrice(Saetze.saetze.d.grundbedarf)
            break;
        case 'fachschule':
            $this.el$('results.anspruch').value = formatPrice(Saetze.saetze.f.grundbedarf)
            break;
        default:
            $this.el$('results.anspruch').value = formatPrice(0)
            $this.el$('results.wohnzuschlag').value = formatPrice(0)
            break;

    }
}

/**
 * Bedarf Schüler-Bafög - mit vorausgesetzter Ausbildung - ausgeben
 * @param $this
 * @param art
 */
function grundbedarf_schule1($this, art){
    switch (art) {
        case 'abend':
            $this.el$('results.anspruch').value = formatPrice(Saetze.saetze.e.grundbedarf)
            break;
        case 'kolleg':
            $this.el$('results.anspruch').value = formatPrice(Saetze.saetze.g.grundbedarf)
            break;
        default:
            $this.el$('results.anspruch').value = formatPrice(0)
            $this.el$('results.wohnzuschlag').value = formatPrice(0)
            break;
    }
}

/**
 * Funktionen exportieren
 */
export {grundbedarf_stud,grundbedarf_meister,grundbedarf_schule,grundbedarf_schule1};
